'use client';

import houseIcon from '@src/assets/svg/houseIcon';
import TrainIcon from '@src/assets/svg/trainIcon';
import Money from '@src/assets/svg/money';
import { useChat } from '../context/ChatContext';
import { MessageType } from '../types/chat.types';

const suggestions = [
  {
    label: 'Homes under 2K',
    icon: Money,
    question: 'Find me homes under 2K',
  },
  {
    label: 'Homes near BART',
    icon: TrainIcon,
    question: 'Find me homes near BART',
  },
  {
    label: '3 Bedroom Homes',
    icon: houseIcon,
    question: 'Find me homes with 3 bedrooms',
  },
];

export default function QuickSuggestions() {
  const { sendMessage, isStreaming } = useChat();

  const handleClick = async (question: string) => {
    await sendMessage(question, MessageType.QUICK_SUGGESTION);
  };

  return (
    <div
      className="mt-6
        px-[20px]
        pt-[24px]
        pb-[16px]
        "
    >
      <p className="mb-3 text-md text-gray-400">Try these!</p>

      <div
        className="
          flex
          gap-3
          overflow-x-auto
          whitespace-nowrap
          pb-1
          scrollbar-hide
        "
      >
        {suggestions.map(({ label, icon: Icon, question }, index) => (
          <button
            key={index}
            onClick={() => handleClick(question)}
            disabled={isStreaming}
            className="
              flex
              shrink-0
              items-center
              justify-center
              gap-2
              rounded-full
              border
              border-gray-200
              px-[12px]
              py-[8px]
              
              font-[400]
              text-gray-600
              hover:bg-gray-50
              active:scale-95
              transition
              disabled:opacity-50
              disabled:cursor-not-allowed
              disabled:hover:bg-transparent
            "
          >
            <Icon />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
